export default __webpack_public_path__ + "static/media/logo_secondary.c38d759b.png";